export default {
  LocCode: "",
  Description: "",
  UserModified: localStorage.getItem("UserName"),
};
